import moment from 'moment';

import useFlightSearchBar from '../../context/flight';
import FlightDatePicker from './FlightDatePicker';
import { Container } from './styled';

const DateSelection = () => {
  const {
    state: { startDate, endDate },
  } = useFlightSearchBar();

  const start = moment(startDate);
  const end = endDate ? moment(endDate) : null;

  return (
    <Container>
      <FlightDatePicker
        initialDates={{
          startDate: start,
          endDate: end,
        }}
      />
    </Container>
  );
};

export default DateSelection;
